import React from 'react'
import styled from 'styled-components'

const Heading = ({ children }) => {
  return <Wrapper className="heading">{children}</Wrapper>
}

const Wrapper = styled.h2`
  margin-bottom: 0.5em;
  border-bottom: var(--border-width) solid var(--color-primary);
  font-family: var(--font-display);
  font-size: var(--font-size-6);
  line-height: 1.2;
  text-transform: uppercase;
`

export default Heading
